import { Check, X, Minus } from "lucide-react";

import { useTranslation } from 'react-i18next';
function CellValue({ value, isMaxOs }) {
  const { t } = useTranslation();

  if (value === true) {
    return (
      <span className="flex items-center justify-center" aria-label={t('comparison_table.yes')}>
        <Check className="w-5 h-5 text-amber-500" />
      </span>
    );
  }
  if (value === false) {
    return (
      <span className="flex items-center justify-center" aria-label={t('comparison_table.no')}>
        <X className="w-5 h-5 text-zinc-500" />
      </span>
    );
  }
  if (value === "partial") {
    return (
      <span className="flex items-center justify-center" aria-label={t('comparison_table.partial')}>
        <Minus className="w-5 h-5 text-zinc-400" />
      </span>
    );
  }
  return (
    <span className={`text-sm ${isMaxOs ? "text-amber-400 font-medium" : "text-zinc-400"}`}>
      {value}
    </span>
  );
}

export default function ComparisonTable({ features, maxOsName = "Max OS Cloud", competitorName }) {
  const { t } = useTranslation();
  return (
    <section className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
      <h2 className="font-display text-3xl text-white uppercase text-center mb-10">{t('comparison_table.feature_comparison')}</h2>

      {/* Desktop table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full border border-zinc-800">
          <thead>
            <tr className="border-b border-zinc-800 bg-zinc-950/80">
              <th className="text-left font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 px-6 py-4">{t('comparison_table.feature')}</th>
              <th className="text-center font-mono text-[10px] uppercase tracking-[0.2em] text-amber-500 px-4 py-4">
                {maxOsName}
              </th>
              <th className="text-center font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 px-4 py-4">
                {competitorName}
              </th>
            </tr>
          </thead>
          <tbody>
            {features.map((row, idx) => (
              <tr key={idx} className="border-b border-zinc-800/50 hover:bg-zinc-900/30 transition-colors">
                <td className="px-6 py-4 text-sm text-zinc-300 font-medium">{row.feature}</td>
                <td className="text-center px-4 py-4">
                  <div className="flex flex-col items-center gap-1">
                    <CellValue value={row.maxOs} isMaxOs={true} />
                    {row.maxOsDetail && (
                      <span className="text-[10px] text-zinc-500 font-mono">{row.maxOsDetail}</span>
                    )}
                  </div>
                </td>
                <td className="text-center px-4 py-4">
                  <div className="flex flex-col items-center gap-1">
                    <CellValue value={row.competitor} isMaxOs={false} />
                    {row.competitorDetail && (
                      <span className="text-[10px] text-zinc-500 font-mono">{row.competitorDetail}</span>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="md:hidden space-y-4">
        {features.map((row, idx) => (
          <div key={idx} className="border border-zinc-800 bg-zinc-950/50 p-4">
            <p className="text-white text-sm font-medium mb-3">{row.feature}</p>
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-amber-500 mb-2">
                  {maxOsName}
                </p>
                <CellValue value={row.maxOs} isMaxOs={true} />
                {row.maxOsDetail && (
                  <p className="text-[10px] text-zinc-500 font-mono mt-1">{row.maxOsDetail}</p>
                )}
              </div>
              <div className="text-center">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">
                  {competitorName}
                </p>
                <CellValue value={row.competitor} isMaxOs={false} />
                {row.competitorDetail && (
                  <p className="text-[10px] text-zinc-500 font-mono mt-1">{row.competitorDetail}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
